import React, { useCallback, useEffect, useState } from 'react'
import './styles.scss'
import { Empty, Modal } from 'antd'
import AddFile from './AddFile'
import DeleteFile from './DeleteFile'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import LoadingSpinner from '../LoadingSpinner'
import { v4 as uuidv4 } from 'uuid'

const LandingPage = () => {
  const [activeInd, setActiveInd] = useState<number>(0)
  const [isUpdateButtonClicked, setIsUpdateButtonClicked] = useState(false)
  const [selected, setSelected] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isResponse, setIsResponse] = useState<any>(null)
  // const [selectIndex, setSelectIndex] = useState(null)
  const location = useLocation()
  const [isModalOpen, setIsModalOpen] = useState<any>('')
  const [isFileName, setIsFileName] = useState<any>(null)
  const navArray = ['Development', 'Production', 'Archive']
  const navigate = useNavigate()

  useEffect(() => {
    if (location.pathname === '/excel') {
      localStorage.removeItem('uploadedFileName')
    }
  }, [location.pathname])

  useEffect(() => {
    uploadedFilesApi()
  }, [])

  const uploadedFilesApi = useCallback(async () => {
    setIsLoading(true) // Start loading
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CSV_ANALYTICS_URL}/csv-analytics/files`,
        { withCredentials: true }
      )
      console.log(response, 'files')
      setIsResponse(response)
    } catch (error) {
      console.log(error, 'error')
    } finally {
      setIsLoading(false) // End loading
    }
  }, [])

  const openFileModal = () => {
    setIsModalOpen('file')
  }

  const closeFileModal = () => {
    setIsModalOpen(false)
  }

  console.log(process.env.REACT_APP_CSV_ANALYTICS_URL)

  const openDeleteModal = (id: any) => {
    setIsModalOpen('delete')
  }

  const closeDeleteModal = () => {
    setIsModalOpen(false)
  }

  const updateTable = [
    { id: 'u1', name: 'Duplicate Project', icon: 'bi bi-copy' },
    { id: 'u2', name: 'Move to Archive', icon: 'bi bi-archive' },
    { id: 'u3', name: 'Delete', icon: 'bi bi-trash' }
  ]

  const color = ['#7703fc', '#0f4ce5', '#21cd99']

  const activeHandler = (e: any) => {
    setActiveInd(e)
  }

  const updateHandler = (id: any) => {
    setSelected(id)
    setIsUpdateButtonClicked(!isUpdateButtonClicked)
  }

  const filterHandler = (id: any) => {
    setIsFileName(id)
  }

  const generateTableData = (file: any) => {
    const tableHeadArr: any = []
    const tableBodyArr: any = []

    file?.top_6_data?.forEach((data: any, index: number) => {
      const firstFourKeys = Object.keys(data).slice(0, 3)

      if (index === 0) {
        firstFourKeys.forEach((key) => {
          if (!tableHeadArr.includes(key)) {
            tableHeadArr.push(key)
          }
        })
      }
      const row = firstFourKeys.map((key) => data[key])
      tableBodyArr.push(row)
    })

    return {
      tableHeadArr,
      tableBodyArr,
      tableBottomData: {
        name: file?.filename,
        created: file?.upload_time
      }
    }
  }

  const handleTableClick = (fileName: string) => {
    localStorage.setItem('uploadedFileName', fileName)
    navigate('/excel_table')
  }

  if (isLoading || !isResponse) {
    return <LoadingSpinner />
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '20px', overflow: 'hidden' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          borderBottom: '1px solid hsl(240, 17.4%, 91%)'
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <p style={{ display: 'flex', gap: '20px', fontSize: '20px' }}>
            <span>Project</span>
            <span style={{ color: 'hsl(240, 12.4%, 70%)' }}>{isResponse?.data?.files?.length}</span>
          </p>
          <p style={{ display: 'flex', gap: '10px' }}>
            <span>
              <input
                placeholder='Search Projects'
                style={{ padding: '8px', border: '1px solid hsl(240, 17.4%, 91%)' }}
              />
            </span>
            <span style={{ padding: '7px', border: '1px solid hsl(240, 17.4%, 91%)' }}>
              <i className='bi bi-filter' style={{ fontSize: '20px' }}></i>
            </span>
          </p>
        </div>
        <div style={{ display: 'flex', gap: '20px' }}>
          {navArray?.map((item: any, ind: any) => (
            <p
              key={uuidv4()}
              style={{
                marginBottom: '0px',
                fontSize: '16px',
                cursor: 'pointer',
                color: 'hsl(240, 10%, 59%)'
              }}
              className={activeInd === ind ? 'active_class' : ''}
              onClick={() => activeHandler(ind)}
            >
              {item}
            </p>
          ))}
        </div>
      </div>

      {activeInd == 0 ? (
        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: '32px',
            marginTop: '40px',
            overflow: 'scroll'
          }}
        >
          <div
            onClick={openFileModal}
            style={{
              border: '1px dashed black',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              width: '100%',
              textAlign: 'center',
              height: '100%',
              cursor: 'pointer',
              padding: '10px'
            }}
            className='hoverEffect'
          >
            <p>
              <span
                style={{
                  fontSize: '40px',
                  border: 'none',
                  borderRadius: '50%',
                  padding: '5px 20px',
                  overflow: 'hidden',
                  background: '#00a3ff',
                  color: 'white'
                }}
              >
                +
              </span>
            </p>
            <span style={{ color: 'hsl(218, 80.3%, 47.8%)', fontSize: '16px' }}>
              Create New project
            </span>
          </div>

          {isResponse?.data?.files?.map((file: any, fileIndex: any) => {
            const { tableHeadArr, tableBodyArr, tableBottomData } = generateTableData(file)

            return (
              <div key={uuidv4()} style={{ display: 'flex', flexDirection: 'column' }}>
                <div
                  style={{ border: '1px solid hsl(240, 17.4%, 91%)', borderRadius: '15px' }}
                  className='table-hover'
                >
                  <div
                    onClick={() => handleTableClick(file.filename)}
                    style={{ cursor: 'pointer' }}
                  >
                    <table style={{ width: '100%' }}>
                      <thead style={{ borderTop: `3px solid ${color[fileIndex % color.length]}` }}>
                        <tr>
                          {tableHeadArr?.map((el: any, ind: any) => (
                            <td
                              key={uuidv4()}
                              style={{
                                borderRight: '1px solid hsl(240, 14.6%, 83.9%)',
                                borderBottom: '1px solid hsl(240, 14.6%, 83.9%)',
                                padding: '8px',
                                background: '#f2faff',
                                color: 'hsl(240, 46.3%, 8%)'
                              }}
                            >
                              {el}
                            </td>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {tableBodyArr?.map((row: any, rowIndex: any) => (
                          <tr
                            key={uuidv4()} // Added a key to help React identify items efficiently
                            style={{
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              position: 'relative'
                            }}
                          >
                            {row.map((cell: any, cellIndex: any) => (
                              <td
                                key={uuidv4()} // Added a key to help React identify items efficiently
                                style={{
                                  borderRight: '1px solid hsl(240, 14.6%, 83.9%)',
                                  borderBottom: '1px solid hsl(240, 14.6%, 83.9%)',
                                  padding: '8px',
                                  color: 'hsl(240, 8%, 50%)',
                                  position: 'relative',
                                  zIndex: 2
                                }}
                              >
                                {cell}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '8px',
                        position: 'relative'
                      }}
                    >
                      <p
                        style={{
                          display: 'flex',
                          gap: '10px',
                          alignItems: 'center',
                          marginTop: '5px',
                          marginBottom: '5px'
                        }}
                      >
                        <span>
                          <i className='bi bi-record-circle'></i>
                        </span>

                        <span style={{ fontSize: '14px', color: 'hsl(240, 10%, 59%)' }}>
                          Not Deployed
                        </span>
                        <div className='blur-background'></div>
                      </p>
                      <span onClick={() => updateHandler(fileIndex)} style={{ cursor: 'pointer' }}>
                        ...
                      </span>
                      {selected == fileIndex && isUpdateButtonClicked && (
                        <div
                          style={{
                            position: 'absolute',
                            bottom: '40px',
                            zIndex: '99',
                            background: 'white',
                            right: '0',
                            boxShadow:
                              '0px 4px 6px -2px rgba(18, 18, 23, .05), 0px 10px 15px -3px rgba(18, 18, 23, .08)',
                            border: '1px solid hsl(240, 14.6%, 83.9%)',
                            paddingBottom: '0'
                          }}
                        >
                          {updateTable?.map((item, el) => (
                            <p
                              key={item.id}
                              style={{
                                display: 'flex',
                                gap: '10px',
                                color: el == 2 ? 'hsl(10, 87.8%, 48%)' : 'hsl(240, 46.3%, 8%)',
                                borderTop: el == 2 ? '1px solid hsl(240, 14.6%, 83.9%)' : '',
                                padding: ' 7px 10px',
                                margin: '0',
                                fontSize: '15px',
                                fontFamily: 'sans-serif',
                                cursor: 'pointer'
                              }}
                              onClick={() => filterHandler(file.filename)}
                            >
                              <span>
                                <i
                                  className={item.icon}
                                  style={{
                                    color: el == 2 ? 'hsl(10, 87.8%, 48%)' : 'hsl(240, 10%, 59%)'
                                  }}
                                ></i>
                              </span>
                              <span
                                onClick={() => {
                                  // filteredIndex(item)
                                  openDeleteModal(item.id == 'u3')
                                }}
                              >
                                {item?.name}
                              </span>
                            </p>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                </div>
                <p style={{ marginBottom: '0px', marginTop: '20px', fontSize: '16px' }}>
                  {tableBottomData.name}
                </p>
                <span style={{ color: 'hsl(240, 7.2%, 46.3%)', fontSize: '14px' }}>
                  Created on {tableBottomData.created}
                </span>
              </div>
            )
          })}
        </div>
      ) : (
        <Empty
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexDirection: 'column',
            margin: '0',
            height: '60vh',
            width: '100%'
          }}
        />
      )}
      {isModalOpen == 'file' && (
        <Modal
          title='Upload Table'
          open={true}
          onCancel={closeFileModal}
          footer={null}
          destroyOnClose
        >
          <AddFile closeFileModal={closeFileModal} uploadedFilesApi={uploadedFilesApi} />
        </Modal>
      )}
      {isModalOpen === 'delete' && (
        <Modal
          width={400}
          title='Delete Project'
          open={true}
          onCancel={closeDeleteModal}
          footer={null}
          destroyOnClose
        >
          <DeleteFile
            fileName={isFileName}
            uploadedFilesApi={uploadedFilesApi}
            closeDeleteModal={closeDeleteModal}
          />
        </Modal>
      )}
    </div>
  )
}

export default LandingPage
